// components/TechnicalErrorModal.jsx

"use client"

import { motion, AnimatePresence } from "framer-motion"

export default function TechnicalErrorModal({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="bg-[#F9F6EB] w-full max-w-[650px] mx-4 p-8 text-center shadow-lg text-[#2B2B2B]"
          >
            <div className="flex flex-col items-center gap-4">
              <h2 className="text-[24px] font-semibold">
                Please Start Over
              </h2>

              <p className="text-[#333] text-base mt-2">
                Sorry about that! A technical error occurred, and you'll need to restart the process.
                <br />
                The details you entered will be cleared once you continue.
              </p>

              <p className="text-[#333] text-base flex items-center gap-1">
                <span>✨</span>
                Don't worry—any orders you've already placed are safe.
              </p>

              <button
                onClick={onClose}
                className="mt-6 bg-orange text-white font-semibold w-[145px] h-[46px] rounded-[3px] text-[18px] justify-center flex items-center gap-2 group hover:bg-orange-600 transition-colors"
              >
                Start Over
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}